<template>
    <span :class="icon" :title="title" class="icon" tabindex="0" @click="clicked" @keyup.enter="clicked">
        <ArrowDown v-if="icon === 'down-icon'" />
        <ArrowUp v-if="icon === 'up-icon'" />
    </span>
</template>

<script>
    import { ArrowDown, ArrowUp } from '@element-plus/icons-vue';

    export default {
        name: 'IconButton',
        components: {
            ArrowDown,
            ArrowUp,
        },
        props: {
            icon: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                default: null,
            },
        },
        emits: ['click'],
        methods: {
            clicked() {
                this.$emit('click');
            },
        },
    };
</script>
